export const AgeUnit = {
  None: "",
  Years: "years",
  Months: "mo.",
} as const;

const AgePrefix = {
  None: "",
  Age: "Age",
} as const;

export type AgeUnit = (typeof AgeUnit)[keyof typeof AgeUnit];
export type AgePrefix = (typeof AgePrefix)[keyof typeof AgePrefix];

interface GetUserAgePayload {
  ageNumber: number;
  ageUnit: AgeUnit;
  agePrefix: AgePrefix;
  ageString: string;
}

export default (
  birthDate: Date | string,
  compareDate?: Date
): GetUserAgePayload => {
  let ageNumber = 0;
  let ageUnit: AgeUnit = AgeUnit.None;
  let agePrefix: AgePrefix = AgePrefix.Age;
  let ageString = "";

  if (!birthDate) {
    return {
      ageNumber,
      ageUnit,
      agePrefix,
      ageString,
    };
  }

  const userBirthDate = new Date(birthDate);
  const today = compareDate ? new Date(compareDate) : new Date();
  const yearsDifference =
    today.getUTCFullYear() - userBirthDate.getUTCFullYear();
  const monthsDifference = today.getUTCMonth() - userBirthDate.getUTCMonth();
  let monthAge = yearsDifference * 12 + monthsDifference;

  if (today.getUTCDate() < userBirthDate.getUTCDate()) {
    monthAge -= 1;
  }

  ageNumber = Math.floor(monthAge / 12);

  if (ageNumber < 0) {
    return {
      ageNumber: 0,
      ageUnit,
      agePrefix,
      ageString,
    };
  }

  ageUnit = AgeUnit.Years;
  ageString = `${agePrefix} ${ageNumber}`;

  if (monthAge < 24) {
    ageNumber = monthAge;
    ageUnit = AgeUnit.Months;
    agePrefix = AgePrefix.None;
    ageString = `${ageNumber} ${ageUnit}`;
  }

  return {
    ageNumber,
    ageUnit,
    agePrefix,
    ageString,
  };
};
